import { render, staticRenderFns } from "./FavoritesListPanel.vue?vue&type=template&id=5475574b&scoped=true&"
import script from "./FavoritesListPanel.vue?vue&type=script&lang=js&"
export * from "./FavoritesListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475574b",
  null
  
)

export default component.exports